export const GOOGLE_ANALYTICS_ID_COOKIE_NAME = '_ga';
export const TRACKING_CONTEXT_SCHEMA = 'iglu:com.gitlab/customer_standard/jsonschema/1-0-4';
export const SNOWPLOW_JS_SOURCE = 'customers-javascript';

export const FLOW_CATEGORY = Object.freeze({
  newPurchase: 'new_purchase',
  editPurchase: 'edit_purchase',
  renewPurchase: 'renew_purchase',
});

export const TRACKING_ACTIONS = Object.freeze({
  stepActivated: 'step_activated',
  stepCompleted: 'step_completed',
  stepEdited: 'step_edited',
  stepFailed: 'step_failed',
  addNewCard: 'add_new_card',
  purchaseSubscription: 'purchase_subscription',
  changeActiveUser: 'change_active_user',
  viewSubscription: 'view_subscription',
  copyActivationCode: 'copy_activation_code',
  renewSubscriptionSM: 'renew_subscription_sm',
  renewSubscriptionSaaS: 'renew_subscription_saas',
  buyCIMinutes: 'buy_ci_minutes',
  buyStorage: 'buy_storage_plan',
  buyDuoProSeats: 'buy_duo_pro_seats',
  changeSubscriptionRampSaaS: 'change_subscription_ramp_saas',
  changeSubscriptionRampSM: 'change_subscription_ramp_sm',
  changeSubscriptionResellerSaaS: 'change_subscription_reseller_saas',
  changeSubscriptionResellerSM: 'change_subscription_reseller_sm',
  cancelSubscriptionSaaS: 'cancel_subscription_saas',
  cancelSubscriptionSM: 'cancel_subscription_sm',
  clickButton: 'click_button',
  clickCard: 'click_card',
  clickLink: 'click_link',
  clickPurchaseSeats: 'click_purchase_seats',
  clickInvoiceDetail: 'click_invoice_detail',
  clickPayInvoice: 'click_pay_invoice',
  clickChange: 'click_change',
  clickModal: 'click_modal',
  clickUpgrade: 'click_upgrade',
  clickRenew: 'click_renew',
  clickSideMenu: 'click_side_menu_item',
  updateGroup: 'update_group',
  updateSeatCount: 'update_seat_count',
  selectPaymentMethod: 'select_payment_method',
  addNewPaymentMethod: 'add_new_payment_method',
  clickTermsCheckbox: 'click_terms_checkbox',
  clickApplyPromoCodeButton: 'click_apply_promo_code_button',
  applyPromoCode: 'apply_promo_code',
  removePromoCode: 'remove_promo_code',
  promoCodeSuccessResponse: 'promo_code_success_response',
  promoCodeFailureResponse: 'promo_code_failure_response',
  clickConfirmPurchase: 'click_confirm_purchase',
  clickAcceptTerms: 'click_accept_terms',
  clickUpdateBillingAccount: 'click_update_billing_account',
  updateCustomerInfo: 'update_customer_info',
  transactionSuccessful: 'transaction_successful',
  transactionFailed: 'transaction_failed',
  clickInviteBillingAccountManager: 'click_invite_billing_account_manager',
  confirmInviteBillingAccountManager: 'confirm_invite_billing_account_manager',
  clickRemoveBillingAccountManager: 'click_remove_billing_account_manager',
  clickConfirmBillingAccountManager: 'click_confirm_billing_account_manager',
  successfulWebstoreLogin: 'successful_webstore_login',
  webstoreSigninCtaClick: 'webstore_signin_cta_click',
});

export const TRACKING_CATEGORIES = Object.freeze({
  webstore: 'Webstore',
  webstoreUnified: 'webstore_unified',
});

export const TRACKING_LABELS = Object.freeze({
  success: 'success',
  failed: 'failed',
  confirmPurchase: 'confirm_purchase',
  buyStorage: 'buy_storage_plan',
  cancelSubscriptionSaaS: 'cancel_subscription_saas',
  cancelSubscriptionSM: 'cancel_subscription_sm',
  changeNamespace: 'change_namespace',
  resumeSubscriptionSaaS: 'resume_subscription_saas',
  resumeSubscriptionSM: 'resume_subscription_sm',
  renewSubscriptionSM: 'renew_subscription_sm',
  renewSubscriptionSaaS: 'renew_subscription_saas',
  buyCIMinutes: 'buy_ci_minutes',
  invoiceDetail: 'invoice_detail',
  payInvoice: 'pay_invoice',
  payInvoiceSuccess: 'pay_invoice_success',
  payInvoiceError: 'pay_invoice_error',
  linkNamespace: 'link_namespace',
  linkNamespaceRamp: 'link_namespace_ramp',
  addSeatsSaaS: 'add_seats_saas',
  addSeatsSM: 'add_seats_sm',
  upgradeSubscriptionSaaS: 'upgrade_subscription_saas',
  upgradeSubscriptionSM: 'upgrade_subscription_sm',
  cancelUpdateProfile: 'cancel_update_profile',
  confirmUpdateProfile: 'confirm_update_profile',
  updateProfile: 'update_profile',
  addDuoProSaaS: 'add_duo_pro_saas',
  addDuoProSM: 'add_duo_pro_sm',
  buyDuoProSaaS: 'buy_duo_pro_saas',
  buyDuoProSM: 'buy_duo_pro_sm',
  inviteBillingAccountManager: 'invite_billing_account_manager',
  removeBillingAccountManager: 'remove_billing_account_manager',
  signInWithExistingAccount: 'sign_in_with_existing_account',
  registerForNewAccount: 'register_for_new_account',
  signInWithLegacyAccount: 'sign_in_with_legacy_account',
});

export const NAV_TRACKING_LABELS = Object.freeze({
  headerInfo: 'header_info',
  headerProfile: 'header_profile',
  headerLogo: 'header_logo',
  subscription: 'subscription',
  invoices: 'invoices',
  billingSettings: 'billing_account_settings',
});
